import { useQuery } from '@tanstack/react-query';

import { apiFetchJson } from '../../lib/apiFetch.js';
import type { OverviewResponse } from './overviewTypes.js';

/**
 * TanStack Query hook for the coarse Home KPI endpoint (`GET /api/v1/overview`).
 *
 * ONE round-trip — the SERVER computes the whole aggregation (MTD tiles, estimate
 * pipeline, invoices-due queue, recent time, fleet alerts, setup nudge); the SPA
 * only renders the returned envelope (no client re-aggregation, no new N+1). The
 * request goes through `apiFetch` (the only fetch path — `credentials:'include'` +
 * `X-Tenant-Subdomain` baked in, single-flight 401 refresh). The tenant is derived
 * server-side from the auth principal; the SPA never sends a tenant id param
 * (SEC-11 / T-22-28-01).
 */

export const OVERVIEW_QUERY_KEY = ['overview'] as const;

export function useOverviewQuery() {
  return useQuery<OverviewResponse>({
    queryKey: OVERVIEW_QUERY_KEY,
    queryFn: () => apiFetchJson<OverviewResponse>('/api/v1/overview'),
  });
}
